import { defineEntity, custom } from './_helpers.js';

export default defineEntity('crisisEvent', {
    declared:                       custom({ scope: 'state' }),
    responding:                     custom({ scope: 'state' }),
    resolved:                       custom({ scope: 'state' }),
    'team.linked':                  custom({ scope: 'state' }),
    'team.unlinked':                custom({ scope: 'state' }),
    'bcp.linked':                   custom({ scope: 'state' }),
    'bcp.unlinked':                 custom({ scope: 'state' }),
    'bia.linked':                   custom({ scope: 'state' }),
    'bia.unlinked':                 custom({ scope: 'state' }),
    'process.linked':               custom({ scope: 'state' }),
    'process.unlinked':             custom({ scope: 'state' }),
    'asset.linked':                 custom({ scope: 'state' }),
    'asset.unlinked':               custom({ scope: 'state' }),
    'vendor.linked':                custom({ scope: 'state' }),
    'vendor.unlinked':              custom({ scope: 'state' }),
    'recoveryResource.linked':      custom({ scope: 'state' }),
    'recoveryResource.unlinked':    custom({ scope: 'state' }),
    'recoveryActivity.linked':      custom({ scope: 'state' }),
    'recoveryActivity.unlinked':    custom({ scope: 'state' }),
    'communication.linked':         custom({ scope: 'state' }),
    'communication.unlinked':       custom({ scope: 'state' }),
    'lessonLearned.linked':         custom({ scope: 'state' }),
    'lessonLearned.unlinked':       custom({ scope: 'state' }),
    'improvementAction.linked':     custom({ scope: 'state' }),
    'improvementAction.unlinked':   custom({ scope: 'state' }),
});
